import React, { useState, useEffect } from 'react'
import { Form, Button, Image } from 'react-bootstrap'
import '../../index.css'
import { connect } from 'react-redux'
import { useAppContext } from "../../Context";
import { FetchLogin, FetchReadServerVersion } from '../../fetcher'
import logo from '../../assets/FAEX_Logo.png'

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [serverVersion, setServerVersion] = useState("");

    const [error, setError] = useState(false)

    const { userHasAuthenticated } = useAppContext();

    useEffect(() => {
        FetchReadServerVersion(setServerVersion)
    }, [])


    function validateForm() {
        return username.length > 0 && password.length > 0;
    }

    function handleSubmit(event) {
        event.preventDefault();
        const loginData = {
            username, password
        }

        FetchLogin(userHasAuthenticated, loginData, setError, "AppStart")
        //FetchLogin(userHasAuthenticated, loginData, setError, "http://localhost:58420/")
    }

    return (
        <div className="login text-center">
            <Image src={logo} rounded />
            <div className="server-environment">{serverVersion}</div>
            <div className="login">
                <Form onSubmit={handleSubmit}>
                    <Form.Group size="lg" controlId="username">
                        {/*<Form.Label>Benutzername</Form.Label>*/}
                        <Form.Control className="text-center"
                            autoFocus
                            value={username}
                            placeHolder="NAME"
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group size="lg" controlId="password">
                        {/*<Form.Label>Passwort</Form.Label>*/}
                        <Form.Control className="text-center"
                            type="password"
                            value={password}
                            placeHolder="PASSWORT"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Form.Group>
                    <Button variant="secondary" block size="lg" type="submit" disabled={!validateForm()}> Login </Button>
                    {error ?
                        <div className="error">Username oder Passwort sind falsch. Bitte probieren Sie es erneut.</div>
                        : null}
                </Form>
            </div>
        </div>
    )
}


const mapStateToProps = state => ({
    
})

export default (Login)